import { useCallback, useContext } from 'react'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import offerPageURL from 'lib/offer/offerPageURL'

import noop from 'lib/function/noop'
import useOffers from 'hooks/Offers/useOffers'
import { useAppSelector } from 'hooks/reduxHooks'
import SearchMapCard from './SearchMapCard/SearchMapCard'
import SearchMapCardLayout from './SearchMapCard/SearchMapCardLayout'
import OfferListEventsContext, { OfferListEvents } from '../../OfferList/OfferListEventsContext'
import styled from 'styled-components'
import { urlHashDatePicker } from 'constants/url'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'

interface Props {
  offerIds: Array<string>
  filters: App.OfferListFilters
  showPerNightPricing?: boolean
  onProductClick?: (offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary, position: number) => void
  onDeselectOffers?: () => void
}

const StyledClickableLink = styled(ClickableLink)`
  pointer-events: auto;
  width: 100%;
`

function SearchResultsMapOfferView(props: Props) {
  const { offerIds, filters, showPerNightPricing = false, onProductClick = noop, onDeselectOffers } = props
  const [offers] = useOffers<App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary>(offerIds)
  const offerErrors = useAppSelector(state => state.offer.offerErrors)

  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  const offer = offers.length > 0 ? offers[0] : undefined

  const onClick = useCallback(() => {
    if (onProductClick && offer) {
      onProductClick(offer, 0)

      dispatchOfferListEvent({
        type: OfferListEvents.productClick,
        offer,
        position: 0,
      })
    }
  }, [offer, onProductClick, dispatchOfferListEvent])
  const offerMetaData = useOfferMetaData(offer?.id ?? '', filters)

  const hidePrice = !!offerMetaData?.hidePricing

  const urlParams = buildSearchParamsFromFilters(filters)

  if (!offer) {
    return offerIds.some(id => !offerErrors[id])
      ? <SearchMapCardLayout isLoading onClose={onDeselectOffers} />
      : null
  }

  return (
    <StyledClickableLink
      key={offer.id}
      to={offerPageURL(offer, urlParams, hidePrice ? urlHashDatePicker : undefined)}
      onClick={onClick}
      preventSwipeClick
      target="_blank"
    >
      <SearchMapCard
        offer={offer}
        filters={filters}
        showPerNightPricing={showPerNightPricing}
        onClose={onDeselectOffers}
      />
    </StyledClickableLink>
  )
}

export default SearchResultsMapOfferView
